import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-3 bg-canvas px-6 text-center">
      <p className="font-mono text-[11px] font-medium uppercase tracking-[.16em] text-faint">404</p>
      <h1 className="font-display text-[22px] font-semibold tracking-[-.015em]">
        Esta pagina no existe
      </h1>
      <p className="max-w-sm text-[13.5px] text-subtle text-pretty">
        Puede que el enlace este mal escrito o que la vista ya no forme parte de SynQ.
      </p>
      <Link
        to="/tablero"
        className="mt-2 rounded-control bg-brand px-4 py-2 text-[13px] font-semibold text-brand-on transition-colors hover:bg-brand-strong"
      >
        Volver al tablero
      </Link>
    </main>
  );
}
